import { useTranslation } from 'react-i18next'
import { useQuery } from '@tanstack/react-query'
import { dailyActivityAPI } from '../../services/api'
import { MoonIcon } from '@heroicons/react/24/outline'
import SleepPhaseBar from './SleepPhaseBar'

export default function SleepSummaryCard({ onNavigate }) {
  const { t } = useTranslation()

  const { data: latestActivity, isLoading } = useQuery({
    queryKey: ['latestActivity'],
    queryFn: () => dailyActivityAPI.getLatest(),
    select: (response) => response.data?.log
  })

  if (isLoading) {
    return (
      <div className="bg-surface-container border rounded-lg p-4 animate-pulse">
        <div className="h-4 bg-gray-200 rounded w-1/2 mb-3" />
        <div className="h-8 bg-gray-200 rounded w-3/4" />
      </div>
    )
  }

  const sleepMinutes = latestActivity?.sleep_duration_minutes
  const hasPhases = latestActivity?.sleep_rem_minutes || latestActivity?.sleep_deep_minutes ||
    latestActivity?.sleep_light_minutes || latestActivity?.sleep_awake_minutes
  const sleepHours = sleepMinutes ? (sleepMinutes / 60).toFixed(1) : null

  return (
    <button
      onClick={() => onNavigate?.('wellness')}
      className="bg-surface-container border rounded-lg p-4 text-left hover:border-purple-300 hover:shadow-sm transition-all w-full"
    >
      <div className="flex items-center mb-3">
        <MoonIcon className="h-5 w-5 text-purple-600 mr-2" />
        <h4 className="text-sm font-medium text-gray-700">
          {t('myProgress.sleepSummary', 'Sleep')}
        </h4>
      </div>
      {sleepHours ? (
        <div className="space-y-2">
          <div className="flex items-baseline">
            <span className="text-2xl font-bold text-gray-900">{sleepHours}</span>
            <span className="text-sm text-gray-500 ml-1">{t('common.hours', 'hours')}</span>
          </div>
          {hasPhases && (
            <SleepPhaseBar log={latestActivity} />
          )}
        </div>
      ) : (
        <p className="text-sm text-gray-400">{t('common.noData', 'No data')}</p>
      )}
    </button>
  )
}
